var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("REPORT - PROFIT / LOSS (STANDART)")])])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-dropdown', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.top",
            value: 'Export Data',
            expression: "'Export Data'",
            modifiers: {
              "top": true
            }
          }],
          staticClass: "float-right mr-1",
          attrs: {
            "variant": "link iq-bg-primary",
            "toggle-class": "text-decoration-none",
            "no-caret": "",
            "size": "sm"
          },
          scopedSlots: _vm._u([{
            key: "button-content",
            fn: function fn() {
              return [_c('span', {
                staticClass: "dropdown-toggle p-0",
                attrs: {
                  "id": "dropdownMenuButton5",
                  "data-toggle": "dropdown"
                }
              }, [_c('i', {
                staticClass: "fa fa-save m-0"
              })])];
            },
            proxy: true
          }])
        }, [_c('b-dropdown-item', {
          attrs: {
            "href": "#",
            "variant": "dark"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-excel mr-2"
        }), _vm._v("Export Excel")]), _c('b-dropdown-item', {
          attrs: {
            "href": "#",
            "variant": "dark"
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf mr-2"
        }), _vm._v("Export PDF")])], 1)];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-row', [_c('b-col', {
          staticClass: "text-center",
          attrs: {
            "md": "12"
          }
        }, [_c('h4', [_vm._v("PT. CAHAYA MARITIM")]), _c('h3', [_vm._v("PROFIT / LOSS (STANDART)")]), _c('p', [_vm._v("Periode : 01 January 2017 - 31 December 2017")])]), _c('b-col', {
          staticClass: "pl-5 pr-5",
          attrs: {
            "md": "12"
          }
        }, [_c('table', {
          staticClass: "table table-striped table-sm"
        }, [_c('thead', [_c('tr', [_c('th', {
          staticClass: "pl-5",
          attrs: {
            "width": "80%"
          }
        }, [_vm._v("DESCRIPTION")]), _c('th', {
          staticClass: "text-right pr-5",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v("01 JAN - 31 DEC 2017")])])]), _c('tbody', [_c('tr', [_c('th', {
          staticClass: "pl-5",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("REVENUE")])]), _c('tr', [_c('td', {
          staticClass: "pl-5"
        }, [_vm._v("Total REVENUE")]), _c('td', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticClass: "pl-5",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("COST OF GOODS SOLD")])]), _c('tr', [_c('td', {
          staticClass: "pl-5"
        }, [_vm._v("Total COST OF GOODS SOLD")]), _c('td', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticClass: "pl-5"
        }, [_vm._v("GROSS PROFIT")]), _c('th', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticClass: "pl-5",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("OPERATING EXPENSES")])]), _c('tr', [_c('td', {
          staticClass: "pl-5"
        }, [_vm._v("Total OPERATING EXPENSES")]), _c('td', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticClass: "pl-5"
        }, [_vm._v("OPERATING REVENUE")]), _c('th', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticClass: "pl-5",
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("OTHER INCOME and EXPENSES")])]), _c('tr', [_c('th', {
          staticStyle: {
            "padding-left": "80px"
          },
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Other Income")])]), _c('tr', [_c('td', {
          staticStyle: {
            "padding-left": "80px"
          }
        }, [_vm._v("Total OtdER INCOME and EXPENSES")]), _c('td', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticStyle: {
            "padding-left": "80px"
          },
          attrs: {
            "colspan": "2"
          }
        }, [_vm._v("Other Expenses")])]), _c('tr', [_c('td', {
          staticStyle: {
            "padding-left": "80px"
          }
        }, [_vm._v("Total Otder Expenses")]), _c('td', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticClass: "pl-5"
        }, [_vm._v("Total OTHER INCOME and EXPENSES")]), _c('th', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])]), _c('tr', [_c('th', {
          staticClass: "pl-5"
        }, [_vm._v("NET PROFIT/LOSS")]), _c('th', {
          staticClass: "text-right pr-5"
        }, [_vm._v("0")])])])])]), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [_c('hr')])], 1)];
      },
      proxy: true
    }])
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }